import { Routes } from '@angular/router';

export const tmsRoutes: Routes = [
    {
        path: 'carriers',
        loadChildren: () =>
            import('./carriers/carriers.routes').then(
                (m) => m.carriersRoutes,
            ),
    },
    {
        path: 'fleet-units',
        loadChildren: () =>
            import('./fleet-units/fleet-units.routes').then(
                (m) => m.fleetUnitsRoutes,
            ),
    },
    {
        path: 'area-place-types',
        loadChildren: () =>
            import('./area-place-types/area-place-types.routes').then(
                (m) => m.areaPlaceTypesRoutes,
            ),
    },
    {
        path: 'area-places',
        loadChildren: () =>
            import('./area-places/area-places.routes').then(
                (m) => m.areaPlacesRoutes,
            ),
    },
    {
        path: 'route-templates',
        loadChildren: () =>
            import('./route-templates/route-templates.routes').then(
                (m) => m.routeTemplatesRoutes,
            ),
    },
];
